import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';

type MuiCard = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiCard'];
  defaultProps?: ComponentsProps['MuiCard'];
  variants?: ComponentsVariants['MuiCard'];
};
type MuiCardActions = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiCardActions'];
  defaultProps?: ComponentsProps['MuiCardActions'];
  variants?: ComponentsVariants['MuiCardActions'];
};

type MuiCardContent = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiCardContent'];
  defaultProps?: ComponentsProps['MuiCardContent'];
  variants?: ComponentsVariants['MuiCardContent'];
};

export const MuiCard: MuiCard = {
  styleOverrides: {
    root: {
      boxShadow:
        '0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.17), 0px 1px 3px rgba(0, 0, 0, 0.2)',
    },
  },
};

export const MuiCardActions: MuiCardActions = {
  styleOverrides: {
    root: {
      padding: '8px 16px 16px 16px',
    },
  },
};

export const MuiCardContent: MuiCardContent = {
  styleOverrides: {
    root: {
      '&:last-child': {
        paddingBottom: 16,
      },
    },
  },
};
